import { NgModule } from '@angular/core';
import { CalculatorClosingRequirementsComponent } from './calculator-closing-requirements.component';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule, PipesModule } from 'common';

@NgModule({
    declarations: [
        CalculatorClosingRequirementsComponent
    ],
    imports: [
        FlexLayoutModule,
        CommonModule,
        MaterialModule,
        PipesModule
    ],
    exports: [
        CalculatorClosingRequirementsComponent
    ]
})
export class CalculatorClosingRequirementsModule { }